import { render, staticRenderFns } from "./Carri.vue?vue&type=template&id=3da8d42f"
import script from "./Carri.vue?vue&type=script&lang=js"
export * from "./Carri.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports